import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Translate, getTranslate, getActiveLanguage } from "react-localize-redux"
import PropTypes from "prop-types"
import LazyLoad from "react-lazyload"
import { showIFrameModal } from "../../redux/modules/Modal"
import { FooterMenuLinks, viFooterMenuLinks } from "../../configs/MenuLinks"
import SBTextLogo from "../../images/logos/sb-text-logo.svg"

class Footer extends React.Component {
	renderMenuGroup = ({ title, titlePath, items }, locale, index) => {
		return (
			<div className="col-lg-3 col-md-6 mb-3 mb-lg-0" key={index}>
				<div className="group-heading">
					<a href={titlePath}>{title}</a>
				</div>
				<ul className="footer-menu">
					{items.map((value, subIndex) =>
						this.renderMenuItems(value, locale, subIndex)
					)}
				</ul>
			</div>
		)
	}

	renderMenuItems = ({ path, title, className }, locale, subIndex) => {
		return (
			<li key={subIndex}>
				<a href={path}>{title}</a>
			</li>
		)
	}

	render() {
		const currentUrl = this.props.location.pathname
		const { currentLanguage } = this.props
		const iFrame_url =
			"//consent-pref.trustarc.com/?type=starbucks&site=starbucks.com&action=notice&country=vn&locale=en&behavior=implied&layout=default_eu&from=http://consent.trustarc.com/"
		return (
			<Translate>
				{(translate, activeLanguage, languages) => {
					const locale = activeLanguage.code
					return (
						<footer id="footer" className="container-fluid">
							{currentLanguage === "en" && (
								<div className="row">
									{FooterMenuLinks.map((value, index) =>
										this.renderMenuGroup(value, locale, index)
									)}
								</div>
							)}
							{currentLanguage === "vi" && (
								<div className="row">
									{viFooterMenuLinks.map((value, index) =>
										this.renderMenuGroup(value, locale, index)
									)}
								</div>
							)}
							<div className="region mt-4">
								<i className="icon icon-flag icon-flag-VN" />
								<b>
									<Translate id="footer.footerMenu._Change_Region" /> »
								</b>
								<span className="footer-link">
									{languages.map(
										(language) =>
											language.active ? (
												<span
													key={language.code}
													className="mx-2">
													<Translate
														id={`footer.footerMenu._${
															language.name
														}`}
													/>
												</span>
											) : (
												<span key={language.code}>
													<a
														href={
															currentUrl &&
															!!currentUrl.length &&
															currentUrl.includes(
																activeLanguage.code
															)
																? currentUrl.replace(
																		`/${
																			activeLanguage.code
																		}/`,
																		`/${
																			language.code
																		}/`
																  )
																: `/${language.code}/`
														}
														className="link link-underline fw6 mx-1 fw-bold color-text-1">
														<Translate
															id={`footer.footerMenu._${
																language.name
															}`}
														/>
													</a>
													<span>»</span>
												</span>
											)
									)}
								</span>
							</div>
							{currentLanguage === "en" && (
								<div className="footer-links mt-2">
									<span className="footer-link">
										<a href="http://en.starbucks.vn/about-us/company-information/online-policies/web-accessibility">
											Web Accessibility
										</a>
									</span>
									<span className="footer-link">
										<a href="http://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement">
											Privacy Statement
										</a>
									</span>
									<span className="footer-link">
										<a href="http://en.starbucks.vn/about-us/company-information/online-policies/terms-of-use">
											Terms of Use
										</a>
									</span>
									<span className="footer-link">
										<a href="http://en.starbucks.vn/site-map">
											Site Map
										</a>
									</span>
									<span className="footer-link">
										<span
											className="link"
											onClick={() =>
												this.props.showIFrameModal(
													iFrame_url,
													"300px",
													"100%"
												)
											}>
											Cookie Preferences
										</span>
									</span>
								</div>
							)}
							{currentLanguage === "vi" && (
								<div className="footer-links mt-2">
									<span className="footer-link">
										<a href="http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/kh%E1%BA%A3-n%C4%83ng-truy-c%E1%BA%ADp-web">
											Khả năng truy cập Web
										</a>
									</span>
									<span className="footer-link">
										<a href="http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/chi-nh-sa-ch-ba-o-m%C3%A2-t-th%C3%B4ng-tin">
											Chính Sách Bảo Mật Thông Tin
										</a>
									</span>
									<span className="footer-link">
										<a href="http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/%C4%91i%E1%BB%81u-kho%E1%BA%A3n-s%E1%BB%AD-d%E1%BB%A5ng">
											Điều khoản Sử dụng
										</a>
									</span>
									<span className="footer-link">
										<a href="http://www.starbucks.vn/site-map">
											Sơ đồ Trang web
										</a>
									</span>
									<span className="footer-link">
										<span
											className="link"
											onClick={() =>
												this.props.showIFrameModal(
													iFrame_url,
													"300px",
													"100%"
												)
											}>
											Tùy Chọn Cookie
										</span>
									</span>
								</div>
							)}
							<div className="copyright row mt-2 align-items-center">
								<div className="col-sm-8">
									{<Translate id="footer._copyright" />}
								</div>
								<div className="col-sm-4 footer-logo text-left text-sm-right mt-sm-0 mt-2">
									<LazyLoad height={60}>
										<img src={SBTextLogo} alt="Starbucks logo" />
									</LazyLoad>
								</div>
							</div>
						</footer>
					)
				}}
			</Translate>
		)
	}
}

Footer.propTypes = {
	location: PropTypes.object.isRequired,
	currentLanguage: PropTypes.string.isRequired,
}

const mapStateToProps = ({ locale }) => ({
	translate: getTranslate(locale),
	currentLanguage: getActiveLanguage(locale).code,
})
const mapDispatchToProps = (dispatch) => ({
	showIFrameModal: bindActionCreators(showIFrameModal, dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/views/layout/Footer.js